import { useSearchParams } from './useSearchParams';

export const useIsWebView = (): boolean => {
  const searchParams = useSearchParams();
  return [...searchParams.entries()].some(
    ([k, v]) => k.toLowerCase() === 'iswebview' && v.toLowerCase() === 'true'
  );
};
